// extracted by mini-css-extract-plugin
export default {"productDetailHeader":"ProfileListCard_productDetailHeader__dC+j+","icons":"ProfileListCard_icons__epKda","logOutIcon":"ProfileListCard_logOutIcon__D8Lve"};